import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { fhSettingsGenericRoutes } from './lib.routes';
import { FhSettingsGenericComponent } from './components/fh-settings-generic.component';
import { FhDropdownModule } from '@fh-client-interaction-frontends/fh-dropdown';
import { FhFormModule } from '@fh-client-interaction-frontends/fh-form';
import { FhPageHeaderModule } from '@fh-client-interaction-frontends/fh-page-header';
import { TranslateModule } from '@ngx-translate/core';
import { FhButtonModule } from '@fh-client-interaction-frontends/fh-button';
import { FhMenuModule } from '@fh-client-interaction-frontends/fh-menu';
import { FhNameBadgeModule } from '@fh-client-interaction-frontends/fh-name-badge';
import { FhInputSwitchModule } from '@fh-client-interaction-frontends/fh-input-switch';
import { DividerModule } from 'primeng/divider';
import { FhCardModule } from '@fh-client-interaction-frontends/fh-card';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(fhSettingsGenericRoutes),
    FhDropdownModule,
    FhFormModule,
    FhPageHeaderModule,
    TranslateModule,
    FhButtonModule,
    FhMenuModule,
    FhNameBadgeModule,
    FhInputSwitchModule,
    DividerModule,
    FhCardModule
  ],
  declarations: [FhSettingsGenericComponent],
  exports: [FhSettingsGenericComponent]
})
export class FhSettingsGenericModule {}
